/**
 * Comprueba si el elemento es un array
 * @param   {*} a
 * @returns {boolean}
 */
const isArray = a => Array.isArray(a);

/**
 * Formatea una lista en base al idioma
 * @param   {Object} arg
 * @param   {string} [arg.locale]
 * @param   {Array}  arg.list
 * @param   {Object} [arg.options]
 * @returns {string}
 */
const formatList = ({ locale = 'default', list, options }) => {
  const defaultOptions = { style: 'long', type: 'conjunction' };
  const mergedOptions = { ...defaultOptions, ...options };
  return new Intl.ListFormat(locale, mergedOptions).format(list);
};

/**
 * @TODO Probar que funciona...
 * Mueve un elemento desde una posición a otra
 * @param   {Object} arg
 * @param   {Array}  arg.data          - Array
 * @param   {Number} arg.moveFromIndex - Índice desde el que se desea mover
 * @param   {Number} arg.moveToIndex   - Índice al que se desea mover
 * @returns {Array}                    - Nuevo array
 */
const rearrangeItem = ({ data: rawData, moveFromIndex, moveToIndex }) => {
  const data = rawData.slice();
  const movingItem = data[moveFromIndex];

  data.splice(moveFromIndex, 1);
  data.splice(moveToIndex, 0, movingItem);

  return data;
};

/**
 * Comprueba si un array superset contiene todos los elementos del array subset
 * @see https://github.com/lodash/lodash/issues/1743
 * @param   {Object} arg
 * @param   {Array}  arg.superset
 * @param   {Array}  arg.subset
 * @returns {boolean}
 */
const arrayContainsArray = ({ superset, subset }) => {
  if (subset.length === 0) return false;
  return subset.every(value => superset.includes(value));
};

/**
 * Comprueba si dos arrays contienen los mismos elementos
 * @param   {Object} arg
 * @param   {Array}  arg.a
 * @param   {Array}  arg.b
 * @returns {boolean}
 */
const arrayEqualsArray = ({ a, b }) => {
  if (!isArray(a) || !isArray(b)) return false;
  if (a.length !== b.length) return false;
  return a.every(value => b.includes(value));
};

export { isArray, formatList, rearrangeItem, arrayContainsArray, arrayEqualsArray };
